export const APPCONFIG = {
  START_FETCH: "APPCONFIG_START_FETCH",
  FAIL_FETCH: "APPCONFIG_FAIL_FETCH",
  FINISH_FETCH: "APPCONFIG_FINISH_FETCH",
};

export const LOGIN = {
  START_FETCH: "LOGIN_START_FETCH",
  FAIL_FETCH: "LOGIN_FAIL_FETCH",
  FINISH_FETCH: "LOGIN_FINISH_FETCH",
};
export const SIGNOUT = {
  SIGNOUT_START_FETCH: "SIGNOUT_START_FETCH",
  SIGNOUT_FINISH_FETCH: "SIGNOUT_FINISH_FETCH",
  SIGNOUT_FAIL_FETCH: "SIGNOUT_FAIL_FETCH",
};
export const ORGANIZATIONENTITES = {
  INITIATE_ORGANIZATION_ENITIES_FETCH: "INITIATE_ORGANIZATION_ENITIES_FETCH",
  ORGANIZATION_ENITIES_SUCCESS: "ORGANIZATION_ENITIES_SUCCESS",
  ORGANIZATION_ENITIES_FAILED: "ORGANIZATION_ENITIES_FAILED",
  INITIATE_ORGANIZATION_AFFILIATIONS: "INITIATE_ORGANIZATION_AFFILIATIONS",
  ORGANIZATION_AFFILIATIONS_SUCCESS: "ORGANIZATION_AFFILIATIONS_SUCCESS",
  ORGANIZATION_AFFILIATIONS_FAILED: "ORGANIZATION_AFFILIATIONS_FAILED",
  ORGANIZATION_ENITIES_FINAL: "ORGANIZATION_ENITIES_FINAL",
};

export const GROUPREPORTSTYPE = {
  GROUP_REPORT_FETCH: "GROUP_REPORT_FETCH",
  GROUP_REPORT_SUCCESS: "GROUP_REPORT_SUCCESS",
  GROUP_REPORT_FAILED: "GROUP_REPORT_FAILED",
  ADD_NEW_GROUP_MEMBER: "ADD_NEW_GROUP_MEMBER",
  SUCCESS_NEW_GROUP_MEMBER: "SUCCESS_NEW_GROUP_MEMBER",
  FAILED_NEW_GROUP_MEMBER: "FAILED_NEW_GROUP_MEMBER",
  CHANGE_UPDATE_CALL: "CHANGE_UPDATE_CALL",
  ADDING_NEW_MEMBER: "ADDING_NEW_MEMBER",
  DELETE_MEMBER: "DELETE_MEMBER",
  SUCCESS_DELETE_MEMBER: "SUCCESS_DELETE_MEMBER",
  FAILD_DELETE_MEMBER: "FAILD_DELETE_MEMBER",
  NEWMEMBER_NOT_ADDED: "NEWMEMBER_NOT_ADDED",
};

export const BALLOTREPORTSTYPE = {
  UPDATE_BALLOT_REPORT_INITIATE: "UPDATE_BALLOT_REPORT_INITIATE",
  UPDATE_BALLOT_REPORT_SUCCESS: "UPDATE_BALLOT_REPORT_SUCCESS",
  UPDATE_BALLOT_REPORT_FAILED: "UPDATE_BALLOT_REPORT_FAILED",
  UPDATED_BALLOT_REPORT_MEMBER: "UPDATED_BALLOT_REPORT_MEMBER",
  BALLOT_REPORT_MEMBER_NOT_UPDATED: "BALLOT_REPORT_MEMBER_NOT_UPDATED",
  UPDATE_BALLOT_REPORTS_STATUS: "UPDATE_BALLOT_REPORTS_STATUS",
  NEED_TO_CALL_BALLOT_API: "NEED_TO_CALL_BALLOT_API",
  BALLOT_MEMBER_NOT_UPDATED: "BALLOT_MEMBER_NOT_UPDATED",
  BALLOT_MEMBER_DELTED_INITIATE: "BALLOT_MEMBER_DELTED_INITIATE",
  BALLOT_MEMBER_DELTED_SUCCESS: "BALLOT_MEMBER_DELTED_SUCCESS",
  FAILD_BALLOT_DELETE_MEMBER: "FAILD_BALLOT_DELETE_MEMBER",
  BALLOT_API_STATUS: "BALLOT_API_STATUS",
};

export const LOOKUP = {
  START_FETCH: "LOOKUP_START_FETCH",
  FAIL_FETCH: "LOOKUP_FAIL_FETCH",
  FINISH_FETCH: "LOOKUP_FINISH_FETCH",
};

export const LOADER = {
  START_LOADER: "START_LOADER",
  END_LOADER: "END_LOADER",
};

export const TOKENREFRESH = {
  START_REFRESH_TOKEN: "START_REFRESH_TOKEN",
  REFRESH_TOKEN_SUCCESS: "REFRESH_TOKEN_SUCCESS",
  REFRESH_TOKEN_FAILED: "REFRESH_TOKEN_FAILED",
};
